import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { Header } from 'components/common/header/Header';
import { useMeetingList } from 'hooks/useMeeting';
import { meetingStore } from 'store/meetingStore';
import './ScheduleSelectMeeting.css';

export const ScheduleSelectMeeting = () => {
    const navigate = useNavigate();
    const { data } = useMeetingList();

    // 컴포넌트 마운트 시 모임 목록 조회
    useEffect(() => {
        meetingStore.onGetMeetingList();
    }, []);

    const meetings = data?.data || [];

    const handleMeetingClick = (meetingId: string) => {
        navigate(`/schedule/main/${meetingId}`);
    };

    return (
        <div className="schedule-select-wrapper">
            <Header title="일정 조율할 모임 선택" isSubPage />

            <div className="schedule-select-content">
                {meetings.length === 0 ? (
                    <div className="schedule-select-empty">
                        <div className="empty-icon">📅</div>
                        <div className="empty-title">참여 중인 모임이 없습니다</div>
                        <div className="empty-description">
                            먼저 모임을 생성하거나 참여해주세요
                        </div>
                        <button
                            className="empty-button"
                            onClick={() => navigate('/meeting/create')}
                        >
                            모임 생성하기
                        </button>
                    </div>
                ) : (
                    <div className="schedule-select-list">
                        <div className="schedule-select-description">
                            일정을 조율할 모임을 선택해주세요
                        </div>
                        {meetings.map((meeting: any) => (
                            <div
                                key={meeting.meetingId}
                                className="schedule-meeting-card"
                                onClick={() => handleMeetingClick(meeting.meetingId)}
                            >
                                <div className="schedule-meeting-icon">📅</div>
                                <div className="schedule-meeting-info">
                                    <div className="schedule-meeting-title">
                                        {meeting.meetingName}
                                        {meeting.isRegularMeeting && (
                                            <span className="schedule-meeting-badge">🔄 정기</span>
                                        )}
                                    </div>
                                    <div className="schedule-meeting-meta">
                                        {meeting.creatorNickname} 주최 · 멤버 {meeting.currentMemberCount || 0}명
                                    </div>
                                </div>
                                <div className="schedule-meeting-arrow">→</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
